import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import BottomNav from './BottomNav'

const Layout = () => {
  return (
    <div className="min-h-screen bg-lux-light-bg dark:bg-lux-dark-bg transition-colors duration-500 pb-20 lg:pb-0">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}

export default Layout